@if(downloadAllowed() || reorder() || chartId()) {
<div class="mb-4 flex justify-end items-center">
  @if (downloadAllowed()) {
    <p-menu #downloadmenu [model]="downloadMenuItems" [popup]="true" appendTo="body" baseZIndex="99999"/>
    <button pButton outlined="true" (click)="downloadmenu.toggle($event)" pTooltip="Descargar datos">
      <i class="fa-solid fa-download"></i>
    </button>
  }

  @if (reorder() && chartData.datasets.length > 1) {
    <button pButton class="ms-2" outlined="true" (click)="reorderDatasets()" pTooltip="Invertir orden datasets">
      <i class="fa-solid fa-shuffle"></i>
    </button>
  }

  @if (chartId(); as id) {
    <cosmos-chart-options-button
      class="ms-2"
      [chartId]="id"
      [sameOriginAllowed]="sameOriginAllowed() && xAxisType() === 'time'"
      (configChange)="onChartOptionsChange($event)"
    />
  }
</div>
}

<cosmos-chart-legend [items]="legendItems" (toggle)="onLegendToggle($event)" />

<div class="chart-wrapper">
  <canvas #myChart [id]="'scatterchart-'+dataset()" baseChart
    [data]="chartData"
    [options]="chartOptions"
    [legend]="false"
    [plugins]="chartPlugins"
    [type]="chartType"></canvas>
</div>
